import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { retryManualVoucherPaymentSapMigration } from '../../../../actions';

const ManualVoucherPaymentSapRetryButton = ({
  manualVoucherPaymentId,
  manualVoucherId,
  corporate,
  dispatchRetryManualVoucherPaymentSapMigration,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRetry = async () => {
    setLoading(true);
    await dispatchRetryManualVoucherPaymentSapMigration({
      manualVoucherPaymentId,
      manualVoucherId,
      corporate,
    });
    setLoading(false);
  };

  return (
    <Button
      size="sm"
      color="warning"
      onClick={handleRetry}
      disabled={loading}
      className="ml-1"
      style={{ padding: '2px 6px', fontSize: '0.75rem' }}
      title="Reintentar migración SAP"
    >
      <i className={loading ? 'fa fa-spinner fa-spin' : 'fa fa-refresh'} />
    </Button>
  );
};

ManualVoucherPaymentSapRetryButton.propTypes = {
  manualVoucherPaymentId: PropTypes.number.isRequired,
  manualVoucherId: PropTypes.number.isRequired,
  corporate: PropTypes.shape({
    date: PropTypes.string.isRequired,
    holderType: PropTypes.string.isRequired,
    corporateId: PropTypes.number.isRequired,
    currency: PropTypes.string,
  }).isRequired,
  dispatchRetryManualVoucherPaymentSapMigration: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchRetryManualVoucherPaymentSapMigration:
    retryManualVoucherPaymentSapMigration,
};

export default connect(
  null,
  mapDispatchToProps,
)(ManualVoucherPaymentSapRetryButton);
